import { createReducer } from '@reduxjs/toolkit';

import { mutableDelete } from 'Internals/utils';
import { jwtAllLoaded, jwtAdded, jwtRemoved, jwtEdited } from '../thunks/jwt.thunks';

import type { SubscriptionJWT } from 'Types/subscription.types';

type SubJWTState = SubscriptionJWT[];

const initialState: SubJWTState = [];

/*
Note: We are using the builder callback for creating a typesafe reducer.
See https://redux-toolkit.js.org/usage/usage-with-typescript#building-type-safe-reducer-argument-objects
*/
export const jwtReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(jwtAllLoaded, (state, action) => {
      return action.payload;
    })
    .addCase(jwtAdded, (state, action) => {
      state.push(action.payload);
    })
    .addCase(jwtEdited, (state, action) => {
      mutableDelete(state, (jwt) => jwt.id === action.payload.id);
      state.push(action.payload);
    })
    .addCase(jwtRemoved, (state, action) => {
      mutableDelete(state, (jwt) => jwt.id === action.payload);
    })
);
